import { BaseStoreItem } from '../BaseStoreItem.ts';
import { StoreConsumable, StoreItemCategory } from '../../entity_datas/StoreEnums.ts';
import { LobbyImage } from '@colonist/types';
export class SIUsernameChange extends BaseStoreItem {
    constructor(...args){
        super(...args), this.category = StoreItemCategory.Consumable, this.type = StoreConsumable.UsernameChange, this.name = {
            key: 'strings:storePage.consumables.usernameChange.title'
        }, this.description = 'strings:storePage.consumables.usernameChange.description', this.price = 1300, this.image = LobbyImage.Guest;
    }
}
